import styled from 'styled-components';

import { Button } from '@xing-com/button';
import { ContentSwitcher as DefaultContentSwitcher } from '@xing-com/content-switcher';
import {
  mediaWide,
  mediaTopBarVisible,
  zIndexElevatedLayer5,
} from '@xing-com/layout-tokens';
import { ListItem } from '@xing-com/list';
import { SkeletonButton, SkeletonRectangle } from '@xing-com/skeleton';
import {
  scale110,
  scale150,
  scale210,
  spaceL,
  spaceM,
  spaceS,
  spaceXXS,
  spaceXL,
  spaceXXL,
  space3XL,
  scale170,
} from '@xing-com/tokens';

export const Section = styled.section`
  margin-top: ${space3XL};
  padding-bottom: ${space3XL};
  /* Keeps the heading clear of the fixed app header when scrolled into view. */
  scroll-margin-top: calc(${scale210} + ${spaceL});
`;

export const StickyButtonRow = styled.div`
  position: sticky;
  top: 0;
  z-index: ${zIndexElevatedLayer5};
  height: ${scale210};

  width: 100vw;
  margin-inline: calc(50% - 50vw);

  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding-right: ${spaceXL};
  box-sizing: border-box;

  @media (min-width: 1267px) {
    padding-right: ${space3XL};
  }

  @media ${mediaTopBarVisible} {
    height: ${scale170};
  }
`;

export const StickyCTADesktop = styled(Button)`
  display: flex;

  @media ${mediaTopBarVisible} {
    display: none;
  }
`;

export const StickyCTATablet = styled(Button)`
  display: none;

  @media ${mediaTopBarVisible} {
    display: flex;
  }
`;

export const Overview = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: ${scale150};
  margin-bottom: ${space3XL};
`;

export const ContentSwitcher = styled(DefaultContentSwitcher)`
  && {
    width: auto;
  }
`;

export const SkeletonOverviewHeading = styled(SkeletonRectangle)`
  width: 60%;

  @media ${mediaWide} {
    width: 45%;
  }
`;

export const ProductHeader = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: ${spaceXXL};

  @media ${mediaWide} {
    display: grid;
    gap: ${spaceXXS} ${spaceXL};
    grid-template-columns: minmax(0, 1fr) auto;
  }
`;

export const ProductTitle = styled.div`
  padding-top: ${spaceM};
  padding-bottom: ${spaceM};

  @media ${mediaWide} {
    grid-column: 1;
    grid-row: 1;
  }
`;

export const Intro = styled.div`
  flex: 1;
  padding-bottom: ${spaceM};

  @media ${mediaWide} {
    grid-column: 1;
    grid-row: 2;
  }
`;

export const ActivationButton = styled(Button)`
  flex-shrink: 0;

  @media ${mediaWide} {
    align-self: center;
    grid-column: 2;
    grid-row: 2;
  }
`;

export const SkeletonProductTitle = styled(SkeletonRectangle)`
  margin-bottom: ${space3XL};
  width: 35%;
`;

export const SkeletonIntro = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spaceS};
`;

export const SkeletonActivationButton = styled(SkeletonButton)`
  flex-shrink: 0;

  @media ${mediaWide} {
    align-self: center;
    grid-column: 2;
    grid-row: 2;
  }
`;

export const Groups = styled.div`
  width: 100%;
`;

export const SkeletonGroupHeading = styled(SkeletonRectangle)`
  width: 45%;
`;

export const SkeletonPerk = styled.div`
  align-items: center;
  display: flex;
  gap: ${spaceS};
  min-height: ${scale110};

  & + & {
    margin-top: ${spaceL};
  }
`;

export const SkeletonPerkText = styled(SkeletonRectangle)`
  flex: 1;
  width: auto;
`;

export const Group = styled.section`
  display: flex;
  flex-direction: column;
  gap: ${spaceL};
  padding: ${spaceL} 0;
`;

export const Perk = styled(ListItem)`
  align-items: flex-start;
  gap: ${spaceS};
  padding: 0;

  & + & {
    margin-top: ${spaceL};
  }

  & > svg {
    flex-shrink: 0;
  }
`;

export const PerkText = styled.span`
  flex: 0 1 auto;
  min-width: 0;
`;
